<template>
    <a-breadcrumb>
        <a-breadcrumb-item :key="index" v-for="(item, index) in breadList">
            <router-link :to="item.path">{{ item.meta.title }}</router-link>
        </a-breadcrumb-item>
    </a-breadcrumb>
</template>

<script>
export default {
    data() {
        return {
            breadList: []
        };
    },
    props: ['show'],
    watch: {
        $route() {
            this.getBreadcrumb();
        }
    },
    methods: {
        isHome(route) {
            return route.name === '/';
        },
        getBreadcrumb() {
            let matched = this.$route.matched;
            //如果不是首页
            if (!this.isHome(matched[0])) {
                matched = [{ path: '/', meta: { title: '首页' } }].concat(matched);
            }
            this.breadList = matched;
        }
    },
    created() {
        this.getBreadcrumb();
    }
};
</script>



// WEBPACK FOOTER //
// src/public/Breadcrumb.vue